import store from '@/store'
import * as PN from '@/utils/PermissionNames'
import { whenFloorsLoaded } from '@/components/map/mapRoute'

// replaces fpm_home_map_by_default: that one asked for the map, which is now where the app starts anyway
const HOME_ON_START_KEY = 'fpm_home_on_start'

export const getHomeOnStart = () => {
  try {
    return localStorage.getItem(HOME_ON_START_KEY) === '1'
  } catch (e) {
    return false
  }
}

export const setHomeOnStart = (value) => {
  try {
    if (value) localStorage.setItem(HOME_ON_START_KEY, '1')
    else localStorage.removeItem(HOME_ON_START_KEY)
  } catch (e) {
    // storage is off: the choice lasts until reload
  }
}

// status 1 is Published
export const hasPublishedFloor = (floors) => floors.some((floor) => floor.status === 1)

// /home would show such a reader only the "not linked" card
export const hasNothingOnHome = async () => {
  if (store.getters['rbac/can'](PN.SETTINGS_CRUD)) return false
  try {
    const response = await store.dispatch('employee/employeesSearch', { params: { email: store.state.auth.user.email } })
    return !response.data.items.length
  } catch (e) {
    return false
  }
}

export const opensOnMap = () =>
  new Promise((resolve) => {
    whenFloorsLoaded(async () => {
      if (!hasPublishedFloor(store.getters['floor/floors'])) return resolve(false)
      resolve(!getHomeOnStart() || (await hasNothingOnHome()))
    })
  })
